// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import "./Sidebar.css";
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Collapse,
//   IconButton,
// } from "@mui/material";
// import {
//   Home as HomeIcon,
//   Assessment as AssessmentIcon,
//   Search as SearchIcon,
//   ManageSearch,
//   Warehouse,
//   DataUsage,
//   ContactPage,
//   ContentPasteSearch,
//   CreditScore,
//   Upload as UploadIcon,
//   ExpandLess,
//   ExpandMore,
//   Equalizer,
//   FindInPage,
//   LocalShipping,
//   Receipt,
//   NewReleases,
//   QrCodeScanner,
//   Menu as MenuIcon,
//   DesignServices as DesignServicesIcon,
//   CreateNewFolder as CreateNewFolderIcon,
//   DocumentScanner as DocumentScannerIcon,
//   Folder as FolderIcon,
//   LibraryBooks as LibraryBooksIcon,
//   Book as BookIcon,
//   PeopleAlt as PeopleAltIcon,
//   Engineering as EngineeringIcon,
//   CallReceived as CallReceivedIcon,
//   Summarize as SummarizeIcon,
//   HeartBroken,
// } from "@mui/icons-material";

// const Sidebar = ({ sidebarOpen, toggleSidebar }) => {
//   const [mobileView, setMobileView] = useState(false);
//   const [menus, setMenus] = useState([
//     { title: "Workspace", route: "/", icon: <HomeIcon /> },
//     { title: "Process Flow Chart", route: "/process-flow-chart", icon: <AssessmentIcon /> },
//     { title: "Management Summary", route: "/management-summary", icon: <ManageSearch /> },
//     { title: "Receiving Modules", route: "/receiving-modules", icon: <LocalShipping /> },
//     {
//       title: "Manufacturing Traceability",
//       route: "/manufacturing-traceability",
//       icon: <Warehouse />,
//       showSubMenu: false,
//       submenus: [
//         { title: "Upload", route: "/manufacturing-traceability/upload", icon: <UploadIcon /> },
//         { title: "PDI Verification", route: "/manufacturing-traceability/tracking", icon: <SearchIcon /> },
//         { title: "Traceability Search", route: "/manufacturing-traceability/search", icon: <FindInPage /> },
//         { title: "Shipment Tracker", route: "/manufacturing-traceability/shipment-tracker", icon: <DataUsage /> },
//         { title: "PDI Witness", route: "/manufacturing-traceability/pdi-witness", icon: <CreditScore /> },
//       ],
//     },
//     { title: "Inspections", route: "/inspections", icon: <ContentPasteSearch /> },
//     {
//       title: "Quality Inspection",
//       route: "/quality-inspection-summary",
//       icon: <SummarizeIcon />,
//       showSubMenu: false,
//       submenus: [
//         { title: "Summary", route: "/quality-inspection-summary", icon: <SummarizeIcon /> },
//         { title: "Graphical Summary", route: "/graphical-summary", icon: <Equalizer /> },
//       ],
//     },
//     {
//       title: "Table-wise Scanning",
//       route: "/table-wise-scanning",
//       icon: <QrCodeScanner />,
//       showSubMenu: false,
//       submenus: [
//         { title: "Design Inputs", route: "/table-wise-scanning/design-inputs", icon: <DesignServicesIcon /> },
//         { title: "Site Planner Inputs", route: "/table-wise-scanning/site-planner-inputs", icon: <CreateNewFolderIcon /> },
//         { title: "Site Supervisor Inputs", route: "/table-wise-scanning/site-supervisor-inputs", icon: <DocumentScannerIcon /> },
//       ],
//     },
//     {
//       title: "Support Documents",
//       route: "/support-documents",
//       icon: <FolderIcon />,
//       showSubMenu: false,
//       submenus: [
//         { title: "Quality", route: "/support-documents/quality", icon: <Equalizer /> },
//         { title: "Engineering", route: "/support-documents/engineering", icon: <EngineeringIcon /> },
//         { title: "Receiving", route: "/support-documents/receiving", icon: <CallReceivedIcon /> },
//         { title: "Open for All", route: "/support-documents/open-for-all", icon: <PeopleAltIcon /> },
//       ],
//     },
//     {
//       title: "Module Reconciliation",
//       route: "/module-reconciliation-sheet",
//       icon: <ContactPage />,
//       showSubMenu: false,
//       submenus: [
//         { title: "Dashboard", route: "/module-reconciliation-sheet/module-reconciliation-dashboard", icon: <FolderIcon /> },
//         { title: "Damaged Module Information", route: "/module-reconciliation-sheet/module-reconciliation-Damaged", icon: <HeartBroken /> },
//         { title: "Return To Store", route: "/module-reconciliation-sheet/module-reconciliation-Store", icon: <BookIcon /> },
//         { title: "Unaccounted Modules", route: "/module-reconciliation-sheet/module-reconciliation-Unaccounted", icon: <LibraryBooksIcon /> },
//       ],
//     },
//     { title: "Automated Report", route: "/automated-report", icon: <Receipt />,
//       showSubMenu: false,
//       submenus: [
//         { title: "Report Form", route: "/automated-report/report-form", icon: <Receipt /> },
//         { title: "Report Tracker", route: "/automated-report/report-tracker", icon: <SearchIcon /> },
//       ]
//      },
//     { title: "Release Notes Phase-1.0.0", route: "/releasenotes", icon: <NewReleases /> },
//   ]);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const [currentUser, setCurrentUser] = useState(null);

//   // User menu restrictions configuration
//   const userMenuRestrictions = [
//     {
//       username: "ul.susten",
//       hiddenMenus: [
//         "Process Flow Chart",
//         "Automated Report",
//         "Workspace",
//         "Management Summary",
//         "Receiving Modules",
//         "Table-wise Scanning",
//         "Support Documents",
//         "Module Reconciliation",
//         "Release Notes Phase-1.0.0",
//       ],
//     },
//     {
//       username: "waaree.susten",
//       hiddenMenus: [
//         "Process Flow Chart",
//         "Automated Report",
//         "Workspace",
//         "Management Summary",
//         "Receiving Modules",
//         "Quality Inspection",
//         "Table-wise Scanning",
//         "Support Documents",
//         "Module Reconciliation",
//         "Release Notes Phase-1.0.0",
//       ],
//     },
//     {
//       username: "rayzon.susten",
//       hiddenMenus: [
//         "Process Flow Chart",
//         "Automated Report",
//         "Workspace",
//         "Management Summary",
//         "Receiving Modules",
//         "Quality Inspection",
//         "Table-wise Scanning",
//         "Support Documents",
//         "Module Reconciliation",
//         "Release Notes Phase-1.0.0",
//         "Inspections",
//         "Quality",
//       ],
//     }
//   ];

//   useEffect(() => {
//     // Get username from sessionStorage
//     const username = sessionStorage.getItem("username");
//     setCurrentUser(username);

//     checkMobileView();
//     window.addEventListener("resize", checkMobileView);
//     return () => {
//       window.removeEventListener("resize", checkMobileView);
//     };
//   }, []);

//   const checkMobileView = () => {
//     setMobileView(window.innerWidth <= 760);
//     if (window.innerWidth <= 760) toggleSidebar(false);
//   };

//   const isCurrentRoute = (route) => location.pathname.includes(route);

//   const navigateTo = (route) => {
//     navigate(route);
//     if (mobileView) toggleSidebar(false);
//   };

//   const toggleSubMenu = (menuTitle) => {
//     setMenus((prevMenus) =>
//       prevMenus.map((menu) =>
//         menu.title === menuTitle ? { ...menu, showSubMenu: !menu.showSubMenu } : menu
//       )
//     );
//   };

//   const closeAllSubMenus = () => {
//     setMenus((prevMenus) =>
//       prevMenus.map((menu) => ({
//         ...menu,
//         showSubMenu: false,
//       }))
//     );
//   };

//   const handleToggleSidebar = () => {
//     if (sidebarOpen) {
//       closeAllSubMenus();
//     }
//     toggleSidebar(!sidebarOpen);
//   };

//   const isSubMenuSelected = (menu) => {
//     if (menu.submenus) {
//       return menu.submenus.some((submenu) => location.pathname === submenu.route);
//     }
//     return false;
//   };

//   // Filter menus based on user restrictions
//   const getFilteredMenus = () => {
//     if (!currentUser) return menus;

//     const userRestrictions = userMenuRestrictions.find(
//       (user) => user.username === currentUser
//     );

//     if (!userRestrictions) return menus;

//     return menus.filter(
//       (menu) => !userRestrictions.hiddenMenus.includes(menu.title)
//     );
//   };

//   const filteredMenus = getFilteredMenus();

//   return (
//     <Drawer
//       variant={mobileView ? "temporary" : "permanent"}
//       open={sidebarOpen}
//       onClose={handleToggleSidebar}
//       sx={{
//         "& .MuiDrawer-paper": {
//           width: sidebarOpen ? 300 : 60,
//           backgroundColor: "#111827",
//           color: "white",
//           transition: "width 0.3s",
//         },
//       }}
//     >
//       <div className="flex justify-end p-2">
//         <IconButton onClick={handleToggleSidebar}>
//           <MenuIcon style={{ color: "white" }} />
//         </IconButton>
//       </div>
//       <List className="hide-scrollbar">
//         {filteredMenus.map((menu, menuIndex) => (
//           <div key={menuIndex}>
//             <ListItem
//               button
//               onClick={() => (menu.submenus ? toggleSubMenu(menu.title) : navigateTo(menu.route))}
//               selected={isCurrentRoute(menu.route) || isSubMenuSelected(menu)}
//               sx={{
//                 "&:hover": {
//                   backgroundColor: "#2a2f3b",
//                 },
//                 backgroundColor: isCurrentRoute(menu.route) || isSubMenuSelected(menu) ? "#2a2f3b" : "",
//               }}
//             >
//               <ListItemIcon sx={{ color: "white", minWidth: 55 }}>
//                 {menu.icon}
//               </ListItemIcon>
//               <ListItemText
//                 primary={menu.title}
//                 sx={{
//                   opacity: sidebarOpen ? 1 : 0,
//                   visibility: sidebarOpen ? "visible" : "hidden",
//                   transition: "opacity 0.3s, visibility 0.3s",
//                   width: sidebarOpen ? "auto" : 0,
//                   whiteSpace: "nowrap",
//                 }}
//               />
//               {menu.submenus && (menu.showSubMenu ? <ExpandLess /> : <ExpandMore />)}
//             </ListItem>
//             {menu.submenus && (
//               <Collapse in={menu.showSubMenu} timeout="auto" unmountOnExit>
//                 <List component="div" disablePadding className="hide-scrollbar">
//                   {menu.submenus.map((submenu, submenuIndex) => (
//                     <ListItem
//                       button
//                       key={submenuIndex}
//                       onClick={() => navigateTo(submenu.route)}
//                       sx={{
//                         pl: 4,
//                         "&:hover": {
//                           backgroundColor: "#2a2f3b",
//                         },
//                         backgroundColor: isCurrentRoute(submenu.route) ? "#2a2f3b" : "",
//                       }}
//                     >
//                       <ListItemIcon sx={{ color: "white", minWidth: 40 }}>
//                         {submenu.icon}
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={submenu.title}
//                         sx={{
//                           opacity: sidebarOpen ? 1 : 0,
//                           visibility: sidebarOpen ? "visible" : "hidden",
//                           transition: "opacity 0.3s, visibility 0.3s",
//                           width: sidebarOpen ? "auto" : 0,
//                           whiteSpace: "nowrap",
//                         }}
//                       />
//                     </ListItem>
//                   ))}
//                 </List>
//               </Collapse>
//             )}
//           </div>
//         ))}
//       </List>
//     </Drawer>
//   );
// };

// export default Sidebar;

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Sidebar.css";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
} from "@mui/material";
import {
  Home as HomeIcon,
  Assessment as AssessmentIcon,
  ManageSearch,
  Warehouse,
  ContentPasteSearch,
  Upload as UploadIcon,
  ExpandLess,
  ExpandMore,
  Equalizer,
  FindInPage,
  LocalShipping,
  Receipt,
  NewReleases,
  QrCodeScanner,
  Menu as MenuIcon,
  DesignServices as DesignServicesIcon,
  CreateNewFolder as CreateNewFolderIcon,
  DocumentScanner as DocumentScannerIcon,
  Folder as FolderIcon,
  Engineering as EngineeringIcon,
  CallReceived as CallReceivedIcon,
  PeopleAlt as PeopleAltIcon,
  ContactPage,
  HeartBroken,
  Book as BookIcon,
  LibraryBooks as LibraryBooksIcon,
  Summarize as SummarizeIcon,
  Search as SearchIcon,
} from "@mui/icons-material";

// Helper: Check if user has required role
const hasRole = (storedRoles, roleName) => {
  if (!storedRoles) return false;

  let roles = [];
  try {
    const parsed = JSON.parse(storedRoles);
    if (Array.isArray(parsed)) roles = parsed;
  } catch {
    roles = storedRoles.split(",").map(r => r.trim());
  }
  if (Array.isArray(storedRoles)) roles = storedRoles;

  return roles.includes(roleName);
};

const Sidebar = ({ sidebarOpen, toggleSidebar }) => {
  const [mobileView, setMobileView] = useState(false);
  const [menus, setMenus] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const loadRolesAndBuildMenu = () => {
      const storedRoles = sessionStorage.getItem("userRoles");

      const allMenus = [
        { title: "Workspace", route: "/", icon: <HomeIcon />, requiredRole: "Workspace_View" },
        { title: "Inspections", route: "/inspections", icon: <ContentPasteSearch />, requiredRole: "Inspections_View" },
        // { title: "Process Flow Chart", route: "/process-flow-chart", icon: <AssessmentIcon />, requiredRole: "Process_Flow_Chart_View" },
        // { title: "Management Summary", route: "/management-summary", icon: <ManageSearch />, requiredRole: "Management_Summary_View" },
        { title: "Receiving Modules", route: "/receiving-modules", icon: <LocalShipping />, requiredRole: "Receiving_Modules_View" },

        {
          title: "Manufacturing Traceability",
          route: "/manufacturing-traceability",
          icon: <Warehouse />,
          requiredRole: "Manufacturing_Traceability_View",
          showSubMenu: false,
          submenus: [
            { title: "Upload", route: "/manufacturing-traceability/upload", icon: <UploadIcon />, requiredRole: "MT_Upload_View" },
            { title: "PDI Verification", route: "/manufacturing-traceability/tracking", icon: <SearchIcon />, requiredRole: "PDI_Verification_View" },
            { title: "Traceability Search", route: "/manufacturing-traceability/search", icon: <FindInPage />, requiredRole: "Traceability_Search_View" },
            { title: "Shipment Tracker", route: "/manufacturing-traceability/shipment-tracker", icon: <LocalShipping />, requiredRole: "Shipment_Tracker_View" },
            { title: "PDI Witness", route: "/manufacturing-traceability/pdi-witness", icon: <ContentPasteSearch />, requiredRole: "PDI_Witness_View" },
          ],
        },
        {
          title: "Quality Inspection",
          route: "/quality-inspection-summary",
          icon: <SummarizeIcon />,
          requiredRole: "Quality_Inspection_View",
          showSubMenu: false,
          submenus: [
            { title: "Summary", route: "/quality-inspection-summary", icon: <SummarizeIcon />,requiredRole: "Quality_Inspection_View"},
            { title: "Graphical Summary", route: "/graphical-summary", icon: <Equalizer />,requiredRole: "Quality_Inspection_View" },
          ],
        },

        {
          title: "Table-wise Scanning",
          route: "/table-wise-scanning",
          icon: <QrCodeScanner />,
          requiredRole: "Table_Wise_Scanning_View",
          showSubMenu: false,
          submenus: [
            { title: "Design Inputs", route: "/table-wise-scanning/design-inputs", icon: <DesignServicesIcon />, requiredRole: "Design_Inputs_View" },
            { title: "Site Planner Inputs", route: "/table-wise-scanning/site-planner-inputs", icon: <CreateNewFolderIcon />, requiredRole: "Site_Planner_View" },
            { title: "Site Supervisor Inputs", route: "/table-wise-scanning/site-supervisor-inputs", icon: <DocumentScannerIcon />, requiredRole: "Site_Supervisor_View" },
          ],
        },

        {
          title: "Support Documents",
          route: "/support-documents",
          icon: <FolderIcon />,
          requiredRole: "Supported_Documents_View",
          showSubMenu: false,
          submenus: [
            { title: "Quality", route: "/support-documents/quality", icon: <Equalizer />, requiredRole: "SD_Quality_View" },
            { title: "Engineering", route: "/support-documents/engineering", icon: <EngineeringIcon />, requiredRole: "SD_Engineering_View" },
            { title: "Receiving", route: "/support-documents/receiving", icon: <CallReceivedIcon />, requiredRole: "SD_Receiving_View" },
            { title: "Open for All", route: "/support-documents/open-for-all", icon: <PeopleAltIcon />, requiredRole: "SD_Open_For_All_View" },
          ],
        },

        {
          title: "Module reconciliation",
          route: "/module-reconciliation-sheet",
          icon: <ContactPage />,
          requiredRole: "Module_Reconciliation_Sheet_View",
          showSubMenu: false,
          submenus: [
            { title: "Dashboard", route: "/module-reconciliation-sheet/module-reconciliation-dashboard", icon: <FolderIcon />, requiredRole: "Module_Reconciliation_Dashboard_View" },
            { title: "Damaged Module Information", route: "/module-reconciliation-sheet/module-reconciliation-Damaged", icon: <HeartBroken />, requiredRole: "Damaged_Module_Information_View" },
            { title: "Issue & Return", route: "/module-reconciliation-sheet/module-reconciliation-Store", icon: <BookIcon />, requiredRole: "Return_to_Store_View" },
            { title: "Unaccounted Modules", route: "/module-reconciliation-sheet/module-reconciliation-Unaccounted", icon: <LibraryBooksIcon />, requiredRole: "Unaccounted_Modules_View" },
          ],
        },

        {
          title: "Automated Report",
          route: "/automated-report",
          icon: <Receipt />,
          requiredRole: "Automatic_Report_Generator_View",
          showSubMenu: false,
          submenus: [
            { title: "Report Form", route: "/automated-report/report-form", icon: <Receipt />, requiredRole: "Automatic_Report_Form_View" },
            { title: "Report Tracker", route: "/automated-report/report-tracker", icon: <SearchIcon />, requiredRole: "Automatic_Report_Tracker_View" },
          ],
        },

        { title: "Release Notes Phase-1.0.0", route: "/releasenotes", icon: <NewReleases /> },
      ];

      const filteredMenus = allMenus
        .filter(menu => !menu.requiredRole || hasRole(storedRoles, menu.requiredRole))
        .map(menu => ({
          ...menu,
          submenus: menu.submenus
            ? menu.submenus.filter(sub => hasRole(storedRoles, sub.requiredRole))
            : [],
        }))
        .filter(menu => menu.submenus?.length > 0 || menu.route); // Keep if has route or visible subitems

      setMenus(filteredMenus);
    };

    loadRolesAndBuildMenu();

    // Rebuild if roles change (e.g., login/logout in another tab)
    window.addEventListener("storage", loadRolesAndBuildMenu);
    return () => window.removeEventListener("storage", loadRolesAndBuildMenu);
  }, []);

  // Mobile view handler
  useEffect(() => {
    const checkMobile = () => {
      const isMobile = window.innerWidth <= 760;
      setMobileView(isMobile);
      if (isMobile && sidebarOpen) toggleSidebar(false);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, [sidebarOpen, toggleSidebar]);

  const navigateTo = (route) => {
    navigate(route);
    if (mobileView) toggleSidebar(false);
  };

  const toggleSubMenu = (index) => {
    setMenus(prev => prev.map((m, i) => i === index ? { ...m, showSubMenu: !m.showSubMenu } : m));
  };

  const closeAllSubMenus = () => {
    setMenus(prev => prev.map(m => ({ ...m, showSubMenu: false })));
  };

  const handleToggle = () => {
    if (sidebarOpen) closeAllSubMenus();
    toggleSidebar(!sidebarOpen);
  };

  const isActive = (route) => location.pathname.startsWith(route);
  const isSubmenuActive = (submenus) => submenus?.some(s => location.pathname === s.route);

  return (
    <Drawer
      variant={mobileView ? "temporary" : "permanent"}
      open={sidebarOpen}
      onClose={handleToggle}
      sx={{
        "& .MuiDrawer-paper": {
          width: sidebarOpen ? 300 : 60,
          backgroundColor: "#111827",
          color: "white",
          transition: "width 0.3s",
          overflowX: "hidden",
        },
      }}
    >
      <div className="flex justify-end p-2">
        <IconButton onClick={handleToggle}>
          <MenuIcon style={{ color: "white" }} />
        </IconButton>
      </div>

      <List className="hide-scrollbar">
        {menus.map((menu, i) => (
          <div key={i}>
            <ListItem
              button
              onClick={() => menu.submenus?.length > 0 ? toggleSubMenu(i) : navigateTo(menu.route)}
              selected={isActive(menu.route) || isSubmenuActive(menu.submenus)}
              sx={{
                "&:hover": { backgroundColor: "#2a2f3b" },
                backgroundColor: isActive(menu.route) || isSubmenuActive(menu.submenus) ? "#2a2f3b" : "transparent",
              }}
            >
              <ListItemIcon sx={{ color: "white", minWidth: 55 }}>
                {menu.icon}
              </ListItemIcon>
              <ListItemText
                primary={menu.title}
                sx={{
                  opacity: sidebarOpen ? 1 : 0,
                  visibility: sidebarOpen ? "visible" : "hidden",
                  transition: "opacity 0.3s, visibility 0.3s",
                  whiteSpace: "nowrap",
                }}
              />
              {menu.submenus?.length > 0 && (menu.showSubMenu ? <ExpandLess /> : <ExpandMore />)}
            </ListItem>

            {menu.submenus?.length > 0 && (
              <Collapse in={menu.showSubMenu} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {menu.submenus.map((sub, j) => (
                    <ListItem
                      button
                      key={j}
                      onClick={() => navigateTo(sub.route)}
                      selected={location.pathname === sub.route}
                      sx={{
                        pl: 4,
                        "&:hover": { backgroundColor: "#2a2f3b" },
                        backgroundColor: location.pathname === sub.route ? "#2a2f3b" : "",
                      }}
                    >
                      <ListItemIcon sx={{ color: "white", minWidth: 40 }}>
                        {sub.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={sub.title}
                        sx={{
                          opacity: sidebarOpen ? 1 : 0,
                          visibility: sidebarOpen ? "visible" : "hidden",
                          transition: "opacity 0.3s",
                          whiteSpace: "nowrap",
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            )}
          </div>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;